import React from 'react'
import { LocalizationProps, Language } from '../types'
import './LanguagePicker.css'

const LanguagePicker: React.FC<LocalizationProps> = (props: LocalizationProps): React.ReactElement => {

  const { languages, current } = props.localization

  const _handleClick = (event: any) => {
    event.preventDefault()
    props.setLanguage(event.target.value)
  }

  return (
    <select onChange={_handleClick} className="dogley-language-picker">
      {languages && Object.values(languages).map((lang: Language) => (
        <option key={lang.code} value={lang.code} selected={current === lang.code}>
          {lang.label}
        </option>
      ))}
    </select>
  )

}

export default LanguagePicker
